import { Input as SemanticInput } from 'semantic-ui-react';
import styled from 'styled-components';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const InputFile = styled(SemanticInput)`
  &&&&&&& {
    width: 250px;
  }
`;

const InsertError = styled(TextLayoutComponent.Span)`
  color: ${(props) => props.theme.color.textError};
  margin-left: 20px;
`;

const UploadButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    font-size: 14px;
    margin-left: 20px;
    width: 120px;
  }
`;

const UploadVideoContent = styled.div`
  margin-left: 20px;
  display: block;
  display: flex;
  justify-content: space-around;
`;

export {
  InputFile,
  InsertError,
  UploadButton,
  UploadVideoContent,
};
